import styled from 'styled-components'

export const InvestorCard = styled.div`
  width: auto;
  height: 56px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  padding: 12px;
  border: 1px solid var(--color-divider-2);
`
